import React from "react";
import Chip from "@mui/material/Chip";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import { formatLocalDate, formatLocalTime, formatLocalDateTime } from "utils/dateFormatter";
import { GenericListScreen } from "components/GenericListScreen";
import { Column } from "components/GenericListScreen/types";

function LoginHistoryListScreen() {
    // Status color helper
    const getStatusColor = (status: string) => {
        return status === "SUCCESS" ? "success" : "error";
    };

    // Columns Configuration
    const columns: Column[] = [
        {
            Header: "사용자",
            accessor: "userName",
            align: "left",
            width: "15%",
            Cell: ({ row }: any) => (
                <MDBox>
                    <MDTypography variant="button" fontWeight="medium">
                        {row.original.userName}
                    </MDTypography>
                    <br />
                    <MDTypography variant="caption" color="text">
                        {row.original.userEmail}
                    </MDTypography>
                </MDBox>
            )
        },
        { Header: "테넌트", accessor: "tenantName", align: "left", width: "10%" },
        { Header: "로그인 방법", accessor: "loginMethod", align: "center", width: "10%" },
        {
            Header: "상태",
            accessor: "loginStatus",
            align: "center",
            width: "10%",
            Cell: ({ value }: any) => (
                <Chip
                    label={value}
                    color={getStatusColor(value) as any}
                    size="small"
                    sx={{
                        fontWeight: "medium",
                        minWidth: 70,
                    }}
                />
            )
        },
        { Header: "IP 주소", accessor: "ipAddress", align: "left", width: "12%" },
        { Header: "디바이스", accessor: "deviceName", align: "left", width: "10%" },
        {
            Header: "로그인 시간",
            accessor: "loginDt",
            align: "center",
            width: "15%",
            Cell: ({ value }: any) => (
                <MDBox lineHeight={1}>
                    <MDTypography display="block" variant="caption" fontWeight="medium">
                        {formatLocalDate(value)}
                    </MDTypography>
                    <MDTypography variant="caption" color="text" fontWeight="regular">
                        {formatLocalTime(value)}
                    </MDTypography>
                </MDBox>
            )
        },
    ];

    // Data Transformation to match display needs
    const dataTransform = (data: any) => {
        const items = (data.items || []).map((history: any) => ({
            seqId: history.seqId,
            userName: history.userName || "-",
            userEmail: history.userEmail || "-",
            tenantName: history.tenantName || "-",
            loginMethod: history.loginMethod,
            loginStatus: history.loginStatus,
            failureReason: history.failureReason || "-",
            deviceName: history.deviceName || "-",
            ipAddress: history.ipAddress || "-",
            userAgent: history.userAgent || "-",
            loginDt: history.loginDt || null,
        }));

        return {
            items,
            totalCount: data.totalCount || 0
        };
    };

    return (
        <GenericListScreen
            title="로그인 이력 ( LOGIN HISTORY )"
            apiName="LoginHistory.pagedList"
            columns={columns}
            dataTransform={dataTransform}
        />
    );
}

export default LoginHistoryListScreen;
